import React from 'react';
import PropTypes from 'prop-types';

export default function Swirl({ color }) {
  const className = `fill-${color}`;
  return (
    <svg className={className} width="22" height="16" viewBox="0 0 22 16">
      <path
        d="M2.39,17,1,17l.07-2c11.37.39,17.9-4.17,20-14l2,.42C20.83,11.76,13.9,17,2.39,17Z"
        transform="translate(-1 -1)"
      />
    </svg>
  );
}

Swirl.propTypes = {
  color: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/modules/Pricing/Icons/Swirl/index.js